export default "__VITE_ASSET__Cov_grU1__"